// import React from 'react'

// const PatientDashboard = () => {
//   return (
//     <div>PatientDashboard</div>
//   )
// }

// export default PatientDashboard



import React from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';


// Register Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const PatientDashboard = () => {
  // Data for Resting Heart Rate Chart
  const restingHeartRateData = {
    labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
    datasets: [
      {
        label: 'Resting Heart Rate (BPM)',
        data: [75, 72, 78, 80, 76, 74, 73],
        borderColor: '#f4c430',
        backgroundColor: 'rgba(244, 196, 48, 0.2)',
        fill: true,
        tension: 0.4,
        pointBackgroundColor: '#f4c430',
        pointBorderColor: '#fff',
        pointRadius: 5,
      },
    ],
  };

  // Data for Performance Heart Rate Chart
  const performanceHeartRateData = {
    labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
    datasets: [
      {
        label: 'Performance Heart Rate (BPM)',
        data: [115, 123, 118, 125, 120, 122, 119],
        borderColor: '#f4c430',
        backgroundColor: 'rgba(244, 196, 48, 0.2)',
        fill: true,
        tension: 0.4,
        pointBackgroundColor: '#f4c430',
        pointBorderColor: '#fff',
        pointRadius: 5,
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: true,
        backgroundColor: '#1a2a44',
        titleColor: '#fff',
        bodyColor: '#fff',
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
        ticks: {
          color: '#a0a0a0',
        },
      },
      y: {
        beginAtZero: false,
        min: 60,
        max: 130,
        ticks: {
          stepSize: 10,
          color: '#a0a0a0',
        },
        grid: {
          color: '#3a4a64',
        },
      },
    },
  };

  return (
    <div className="app">
      {/* Header Section */}
      <div className="header-section">
        <div className="header-image">
          {/* Placeholder for the image of doctors */}
          <div className="image-placeholder">[Image of Doctors]</div>
        </div>
        <div className="header-text">
          <h4>Welcome back <span>Cara Stevens!</span></h4>
          <p>We would like to take this opportunity to welcome you to our practice and thank you for choosing our physicians to participate in your healthcare. We look forward to providing you with personalized, comprehensive health focusing on wellness and prevention.</p>
        </div>
      </div>

      {/* Health Metrics Section */}
      <div className="metrics-section">
        <MetricCard 
          title="BLOOD PRESSURE" 
          value="110/70" 
          change="10% Higher Then Last Month" 
          changeColor="green" 
          icon="blood-pressure"
        />
        <MetricCard 
          title="BLOOD PRESSURE" 
          value="650" 
          change="0% Less Then Last Month" 
          changeColor="yellow" 
          icon="heart"
        />
        <MetricCard 
          title="GLUCOSE LEVEL" 
          value="88-75" 
          change="12% Higher Then Last Month" 
          changeColor="green" 
          icon="glucose"
        />
        <MetricCard 
          title="BLOOD COUNT" 
          value="9,456/ML" 
          change="22% Less Then Last Month" 
          changeColor="red" 
          icon="blood-count"
        />
      </div>

      {/* Charts Section */}
      <div className="charts-section">
        <div className="chart-card">
          <h3>RESTING HEART RATE</h3>
          <p>72 BPM (Average)</p>
          <div className="chart-container">
            <Line data={restingHeartRateData} options={chartOptions} />
          </div>
        </div>
        <div className="chart-card">
          <h3>PERFORMANCE HEART RATE</h3>
          <div className="chart-container">
            <Line data={performanceHeartRateData} options={chartOptions} />
          </div>
        </div>
      </div>

      {/* Medications Section */}
      <div className="medications-section">
        <h3>MEDICATIONS</h3>
        <ul>
          <li><span className="dot green"></span> Econochlor (chloramphenicol oral) - 1 - 0 - 1</li>
          <li><span className="dot red"></span> Desmopressin tabs - 1 - 1 - 1</li>
          <li><span className="dot yellow"></span> Abciximab-injection - 1 Daily</li>
          <li><span className="dot orange"></span> Kezvara sarilumab - 0 - 0 - 1</li>
          <li><span className="dot purple"></span> Gentamicin-topical - 1 - 1 - 1</li>
          <li><span className="dot blue"></span> Palperidone palmitate - 1 - 1 - 1</li>
          <li><span className="dot teal"></span> Sermorelin-injectable - 1 Daily</li>
        </ul>
      </div>

      {/* Appointments and Reports Section */}
      <div className="appointments-reports-section">
        {/* Upcoming Appointments */}
        <div className="appointments-card">
          <h3>UPCOMING APPOINTMENT</h3>
          <AppointmentCard 
            doctor="Dr Cara Stevens" 
            specialty="Cardiologist" 
            date="12 June 20" 
            time="09:00 - 10:00" 
          />
          <AppointmentCard 
            doctor="Dr Ari Satsu" 
            specialty="Otaryngologist" 
            date="12 June 20" 
            time="09:15 - 10:15" 
          />
          <AppointmentCard 
            doctor="Dr Angela Ramos" 
            specialty="Dentist" 
            date="11 June 20" 
            time="11:00 - 11:30" 
          />
        </div>

        {/* Past Appointments */}
        <div className="appointments-card">
          <h3>PAST APPOINTMENT</h3>
          <PastAppointmentCard treatment="CT Scans" contact="+123 74594555" />
          <PastAppointmentCard treatment="Heart Checkup" contact="+123 34567504" />
          <PastAppointmentCard treatment="Diseases of the Ear" contact="+123 34567573" />
        </div>

        {/* Reports/Documents */}
        <div className="reports-card">
          <h3>REPORTS/DOCUMENTS</h3>
          <ul>
            <li>Blood Report</li>
            <li>Medclaim Documents</li>
            <li>Doctor Prescription</li>
            <li>X-Ray Files</li>
            <li>Urine Report</li>
            <li>Scanned Documents</li>
          </ul>
          <button className="view-all-btn">VIEW ALL</button>
        </div>
      </div>
    </div>
  );
};

// Metric Card Component
const MetricCard = ({ title, value, change, changeColor, icon }) => (
  <div className="metric-card">
    <div className="metric-icon">
      <div className={`icon-placeholder ${icon}`}></div>
    </div>
    <div className="metric-content">
      <h4>{title}</h4>
      <h4>{value}</h4>
      <p className={`change ${changeColor}`}>{change}</p>
    </div>
  </div>
);

// Appointment Card Component
const AppointmentCard = ({ doctor, specialty, date, time }) => (
  <div className="appointment-card">
    <div className="appointment-image">
      <div className="image-placeholder"></div>
    </div>
    <div className="appointment-details">
      <p>{doctor}</p>
      <p>{specialty}</p>
      <p>{date} {time}</p>
    </div>
  </div>
);

// Past Appointment Card Component
const PastAppointmentCard = ({ treatment, contact }) => (
  <div className="past-appointment-card">
    <p>{treatment}</p>
    <p>Contact Number: {contact}</p>
  </div>
);

export default PatientDashboard;